




























import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DateUtils from '@/utils/DateUtils';

@Component({
  components: { Typography }
})
export default class CycleDays extends Vue {
  @Prop() startDate!: string;
  @Prop() endDate!: string;
  @Prop({ default: 'Ending' }) lastDateLabel!: string;
  @Prop({ default: '#910F26' }) lastDateDotColor!: string;

  get cycleDates() {
    return [
      {
        label: 'Starting on',
        date: this.startDate
      },
      {
        label: 'Today',
        date: new Date()
      },
      {
        label: this.lastDateLabel,
        date: this.endDate
      }
    ].map(item => ({
      ...item,
      date: DateUtils.formattedDate({ date: item.date })
    }));
  }
}
